module.exports = __webpack_public_path__ + "media/images/smart_phone/shares/202001/top_goukei-088b5a195e5152c6ce371b60db9dd761.png";